import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider, Env } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { Page } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { Newsletter } from '@utils/backend-api/newsletters';

import Content from './content';

const queryClient = new QueryClient();

interface NewsletterIndexLandingProps {
  initialCurrentUser?: User;
  isGdprRequired: boolean;
  env: Env;
  newsletters: Newsletter[];
}

const NewsletterIndexLanding = ({
  initialCurrentUser,
  isGdprRequired,
  env,
  newsletters,
}: NewsletterIndexLandingProps) => {
  const { Track } = useEventTracking({
    page: Page.NewsletterIndex,
  });
  return (
    <Track>
      <AppContextProvider
        initialCurrentUser={initialCurrentUser}
        isGdprRequired={isGdprRequired}
        env={env}
      >
        <QueryClientProvider client={queryClient}>
          <Content newsletters={newsletters} />
        </QueryClientProvider>
      </AppContextProvider>
    </Track>
  );
};

export default NewsletterIndexLanding;
